import { useEffect, useState } from 'react';

/**
 * React hook for a debounced value.
 * @param value - Value to debounce.
 * @param delay - Delay in ms.
 * @returns Debounced value.
 * @example
 * const debounced = useDebounceValue(search, 300);
 */
export function useDebounceValue<T>(value: T | (() => T), delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
